<template>
  <div v-if="facet.name" class="pt-4 border-0" :class="facet.cssClass">
    <!-- Titel -->
    <div class="h3 title py-0">{{ facetName }}</div>

    <!-- Dropdown für Preis -->
    <div v-if="facet.type === 'price'">
      <item-filter-price></item-filter-price>
    </div>

    <!-- Dropdown für andere Typen -->
    <div v-else class="dropdown">
      <button
          class="btn btn-outline-secondary dropdown-toggle"
          type="button"
          :id="'dropdown-' + _uid"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >
        {{ selectedOptions.length ? selectedOptions.join(', ') : 'Auswählen' }}
      </button>
      <div class="dropdown-menu" :aria-labelledby="'dropdown-' + _uid">
        <div
            v-for="value in facets"
            :key="value.id"
            class="dropdown-item d-flex align-items-center"
            :class="{ disabled: value.count <= 0 }"
            @click="toggleSelection(value)"
        >
          <input
              type="checkbox"
              class="form-check-input mr-2"
              :id="'option-' + value.id + '-' + _uid"
              :checked="isSelected(value.id)"
              :disabled="isLoading || value.count <= 0"
              @click.stop
          />
          <label :for="'option-' + value.id + '-' + _uid" class="mb-0">
            <span class="flex-grow-1" v-html="value.name" />
            <span class="badge badge-secondary ml-2">{{ value.count }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {
  name: "item-filter",

  components: {
    ItemFilterPrice,
  },

  props: {
    facet: {
      type: Object,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      dropdownOpen: false, // Steuert das Öffnen/Schließen des Dropdowns
    };
  },

  computed: {
    facets() {
      return this.facet.values;
    },

    facetName() {
      if (this.facet.translationKey && this.facet.translationKey.length > 0) {
        return this.$translate("Ceres::Template." + this.facet.translationKey);
      }

      return this.facet.name;
    },

    selectedOptions() {
      // Gibt die Namen der ausgewählten Facetten zurück
      return this.selectedFacets
          .filter((selectedFacet) =>
              this.facets.some((facet) => facet.id === selectedFacet.id)
          )
          .map((facet) => facet.name);
    },

    ...mapState({
      selectedFacets: (state) => state.itemList.selectedFacets,
      isLoading: (state) => state.itemList.isLoading,
    }),
  },

  methods: {
    updateFacet(facetValue) {
      const toolbarElements = document.getElementsByClassName("widget-toolbar");

      for (const toolbarElement of toolbarElements) {
        if (toolbarElement.contains(this.$vnode.elm)) {
          window.localStorage.setItem("openFilterToolbar", true);
        }
      }

      this.$store.dispatch("selectFacet", { facetValue });
    },

    isSelected(facetValueId) {
      return (
          this.selectedFacets.findIndex(
              (selectedFacet) => selectedFacet.id === facetValueId
          ) > -1
      );
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen; // Öffnet oder schließt das Dropdown
    },

    toggleSelection(value) {
      if (value.count <= 0 || this.isLoading) return;

      const isSelected = this.isSelected(value.id);
      const updatedFacet = isSelected
          ? this.selectedFacets.filter((facet) => facet.id !== value.id)
          : [...this.selectedFacets, value];

      this.$store.commit("updateSelectedFacets", updatedFacet);
    },
  },
};
</script>
